import React, {
  createContext,
  useState,
  useCallback,
  useContext,
  ComponentType,
  useMemo,
} from 'react';

import { useSelector } from 'react-redux';
import { iStore } from 'domain/interfaces/models';

type AccessContextData = {
  setPermissions(permissions: string[]): void;
  hasAccess(resourcers: string[], actions: string[]): boolean;
};

const AccessContext = createContext<AccessContextData>({} as AccessContextData);

interface iACL {
  [key: string]: string[];
}

const AccessProvider: React.FC = ({ children }) => {
  // consulting redux.
  const RolesACL = useSelector(
    (store: iStore) => store.auth.permissions.resources,
  );
  const { user } = useSelector((store: iStore) => store.auth);
  const accessActions: string[] = [];
  const accessResources: string[] = [];
  const ACL: iACL = {};

  RolesACL?.forEach(e => {
    ACL[e.name] = e.actions.map(action => action.name);
  });

  console.log('ACL: ', ACL);

  const setPermissions = useCallback((permissions: string[]) => {
    console.log(permissions);
  }, []);

  const hasAccess = useCallback(
    (resourcers: string[], actions: string[]): boolean => {
      if (user?.administrator?.system) return true;

      for (let i = 0; i < resourcers.length; i += 1) {
        if (!ACL[resourcers[i]]) return false;

        for (let j = 0; j < actions.length; j += 1) {
          if (ACL[resourcers[i]].includes(actions[j])) return true;
        }
      }
      return false;
    },
    [accessResources, accessActions, user],
  );

  return (
    <AccessContext.Provider value={{ setPermissions, hasAccess }}>
      {children}
    </AccessContext.Provider>
  );
};

const useAccess = () => {
  const context = useContext(AccessContext);
  return context;
};

type withAccessProps = {
  resourcers?: string[];
  actions?: string[];
  permissionsV2?: boolean;
};

function withAccess<P>(
  Component: ComponentType<P>,
): React.FC<P & withAccessProps> {
  const WithAccessComp: React.FC<P & withAccessProps> = ({
    resourcers,
    actions,
    permissionsV2,
    ...rest
  }) => {
    const { hasAccess } = useAccess();

    const access = useMemo(() => {
      if (permissionsV2 === true) return true;
      if (permissionsV2 === false) return false;

      if (!resourcers || !actions) return true;

      return hasAccess(resourcers, actions);
    }, [resourcers, actions, permissionsV2, hasAccess]);

    return access ? <Component {...(rest as P & withAccessProps)} /> : <></>;
  };

  WithAccessComp.displayName = `withPermissions(${
    Component.displayName || Component.name
  })`;

  return WithAccessComp;
}

export { AccessProvider as default, useAccess, withAccess };
